/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { ForgotPasswordRequestBuilderRequestsMetadata, type ForgotPasswordRequestBuilder } from './forgotPassword/index.js';
// @ts-ignore
import { GetSessionRequestBuilderRequestsMetadata, type GetSessionRequestBuilder } from './getSession/index.js';
// @ts-ignore
import { ResetPasswordRequestBuilderRequestsMetadata, type ResetPasswordRequestBuilder } from './resetPassword/index.js';
// @ts-ignore
import { SignInRequestBuilderNavigationMetadata, type SignInRequestBuilder } from './signIn/index.js';
// @ts-ignore
import { SignOutRequestBuilderRequestsMetadata, type SignOutRequestBuilder } from './signOut/index.js';
// @ts-ignore
import { SignUpRequestBuilderNavigationMetadata, type SignUpRequestBuilder } from './signUp/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /auth
 */
export interface AuthRequestBuilder extends BaseRequestBuilder<AuthRequestBuilder> {
    /**
     * The forgotPassword property
     */
    get forgotPassword(): ForgotPasswordRequestBuilder;
    /**
     * The getSession property
     */
    get getSession(): GetSessionRequestBuilder;
    /**
     * The resetPassword property
     */
    get resetPassword(): ResetPasswordRequestBuilder;
    /**
     * The signIn property
     */
    get signIn(): SignInRequestBuilder;
    /**
     * The signOut property
     */
    get signOut(): SignOutRequestBuilder;
    /**
     * The signUp property
     */
    get signUp(): SignUpRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const AuthRequestBuilderUriTemplate = "{+baseurl}/auth";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const AuthRequestBuilderNavigationMetadata: Record<Exclude<keyof AuthRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    forgotPassword: {
        requestsMetadata: ForgotPasswordRequestBuilderRequestsMetadata,
    },
    getSession: {
        requestsMetadata: GetSessionRequestBuilderRequestsMetadata,
    },
    resetPassword: {
        requestsMetadata: ResetPasswordRequestBuilderRequestsMetadata,
    },
    signIn: {
        navigationMetadata: SignInRequestBuilderNavigationMetadata,
    },
    signOut: {
        requestsMetadata: SignOutRequestBuilderRequestsMetadata,
    },
    signUp: {
        navigationMetadata: SignUpRequestBuilderNavigationMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
